import HomePage from './containers/HomePage';
import LoginPage from './containers/LoginPage';
import SignUpPage from './containers/SignUpPage';
import SignUpSuccessPage from './containers/SignUpSuccessPage';
import StudentsPage from './containers/StudentsPage';
import NewStudentPage from './containers/NewStudentPage';
import StudentProfilePage from './containers/StudentProfilePage';
import EditStudentPage from './containers/EditStudentPage';
import ReportsPage from './containers/ReportsPage';
import NotFoundPage from './containers/NotFoundPage';

const routes = [
  {
    path: '/ingresar',
    exact: true,
    component: LoginPage
  },
  {
    path: '/registro',
    exact: true,
    component: SignUpPage
  },
  {
    path: '/registro-exito',
    component: SignUpSuccessPage
  },
  {
    path: '/',
    component: HomePage,
    exact: true,
    private: true
  },
  {
    path: '/alumnos',
    component: StudentsPage,
    exact: true,
    private: true
  },
  {
    path: '/nuevo-alumno',
    component: NewStudentPage,
    private: true
  },
  {
    path: '/alumnos/:id',
    exact: true,
    component: StudentProfilePage,
    private: true
  },
  {
    path: '/alumnos/:id/:view',
    component: StudentProfilePage,
    private: true
  },
  {
    path: '/editar-alumno/:id',
    component: EditStudentPage,
    private: true
  },
  {
    path: '/reportes',
    component: ReportsPage,
    private: true
  },
  {
    component: NotFoundPage
  }
];

export default routes;



// WEBPACK FOOTER //
// ./src/routes.js